import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type DropdownDefinition } from './dropdown.definition';

export class DropdownDefinitionMapper implements DefinitionMapper<'dropdown'> {
  readonly type = 'dropdown';

  extract(
    element: CanvasElementFrom<'dropdown'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'dropdown'>,
  ): PartialDeep<DropdownDefinition> {
    const { title, data, menu } = element.props.content;

    return {
      label: title?.label,
      showLabel: title?.enabled,
      iconName: title?.icon,
      tooltip: title?.tooltip,
      isReadOnly: data?.readonly,
      placeholder: menu?.placeholder,
      styleName: element.props.styleConfig?.styleName,
    };
  }
}
